import { render, staticRenderFns } from "./ProjectBlockDrawingsTab.vue?vue&type=template&id=6d38a33a"
import script from "./ProjectBlockDrawingsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectBlockDrawingsTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectBlockDrawingsTab.vue?vue&type=style&index=0&id=6d38a33a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports